import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoleService } from '../services/role.service';
import { NzMessageService } from 'ng-zorro-antd/message';

/**
 * Generic Role-based Guard
 * Usage:
 *  {
 *    path: 'billing',
 *    canActivate: [requireRoleGuard('app-admin')],
 *    loadComponent: () => import('../pages/settings/billing/billing.component').then(m => m.BillingComponent)
 *  }
 */
export function requireRoleGuard(minRole: string): CanActivateFn {
  return () => {
    const roleService = inject(RoleService);
    const router = inject(Router);
    const message = inject(NzMessageService);

    const hasAccess = roleService.hasAtLeastRole(minRole);

    if (!hasAccess) {
      message.error('Access denied: insufficient permissions.');
      router.navigate(['/forbidden']);
      return false;
    }

    return true;
  };
}
